import FaqItem from "../bob-web-library/components/FaqItem";
import {
  contentTypeAliasAsCssClass,
  getPropValue,
  getUniqueIdForContentTypeAlias,
} from "../logic/contentLogic";

export const renderFaqItemNestedContent = (content, props = {}) => {
  return (
    <FaqItem
      key={getUniqueIdForContentTypeAlias(content.contentTypeAlias)}
      className={contentTypeAliasAsCssClass(content.contentTypeAlias)}
      title={getPropValue(content, "title")}
      description={getPropValue(content, "description")}
    />
  );
};
